import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

/**
 * Component iprAttDestkop specification for desktop
 * @params {object} - react props
 * @returns {JSX}
 */
export const IprAttDesktop = props => {

    const {
        att,
        ipr,
        getJawType,
        jaw,
        setJaw,
        getNumeric,
        getTpJaw,
        section,
        teeth,
        spe
    } = props

    return (
        <section className="specsDesktop">
            <div className="SpecificationMember">
                {getJawType({ ipr, att }).map( jawId =>
                    <div className={(jaw === getTpJaw(jawId).name) ? 'selected' : null} onClick={() => setJaw(getTpJaw(jawId).name)} key={jawId}>
                        {ihm_viewer__dictionary[getTpJaw(jawId).TRANS][locale()]}
                    </div>
                )}
            </div>
            <table>
                <tbody>
                    <tr>
                        {
                            section.map( sect =>
                                    <td  className="SpecificationTooth" key={sect}>
                                        <h3>{ ihm_viewer__dictionary['SPE_'+sect.toUpperCase()][locale()] }</h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                <th></th>
                                                { teeth[jaw].map(item => <th key={item+'mvt'}>{item}</th> )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                spe.ipr.map( special =>
                                                    ipr.length > 0 ?
                                                        <tr className='ipr' key={'ipr'+special+'line'}>
                                                            <td key={'ipr'+special+'title'} className="label">
                                                                { ihm_viewer__dictionary.SPE_IPR_ATT_ITEM[special.toUpperCase()][locale()] }
                                                            </td>
                                                            { teeth[jaw].map( tooth =>
                                                                <td key={'ipr'+special+tooth}>
                                                                    { getNumeric( sect, special, tooth, 'ipr' ) }
                                                                </td>
                                                            ) }
                                                        </tr>:
                                                    null
                                                )
                                            }
                                            {
                                                att.length > 0 ?
                                                    <tr className='empty'>
                                                        <td></td>
                                                        { teeth[jaw].map( j => <td key={'null'+j}></td>) }
                                                    </tr> : null
                                            }
                                            {
                                                spe.att.map( (special, i) =>
                                                    att.length > 0 ?
                                                        <tr className='att' key={'att'+special+'line'}>
                                                            <td key={'att'+special+'title'} className="label"> { ihm_viewer__dictionary.SPE_IPR_ATT_ITEM[special.toUpperCase()][locale()] } </td>
                                                            { teeth[jaw].map( tooth =>
                                                                <td key={'att'+special+tooth}>
                                                                    { ( getNumeric( sect, special, tooth, 'attachments' ) ) ? <span className={'token token'+i}>&nbsp;</span> : null }
                                                                </td>
                                                            ) }
                                                        </tr>:
                                                    null
                                            )}
                                            </tbody>
                                        </table>
                                    </td>
                            )
                        }
                    </tr>
                </tbody>
            </table>
        </section>
    )
 }
